import { actions } from "./slice";
import { db } from "initializer";
import {
  UpdateUserSoundMasterSettings,
  UserSoundMasterSettingsRecord,
} from "./records";
import { DefaultThunk } from "stores";
import { getFavoriteSounds, getSoundsHistories } from "./selectors";
import { Timestamp, doc, onSnapshot, setDoc } from "firebase/firestore";

const soundMasterSettingsRef = (uid: string) =>
  doc(db, "users", uid, "settings", "soundMaster");

export const subscribeUserSoundMasterSettings =
  (uid: string): DefaultThunk<() => void> =>
  (dispatch) => {
    return onSnapshot(soundMasterSettingsRef(uid), (snapshot) => {
      const data: UpdateUserSoundMasterSettings = snapshot.data() || {};
      const settings = UserSoundMasterSettingsRecord(data);
      dispatch(actions.update({ settings }));
    });
  };

// Favorite sounds
export const addFavoriteSound =
  (uid: string, soundId: string): DefaultThunk =>
  async (_, getState) => {
    const state = getState();
    const currentFavorites = getFavoriteSounds(state);

    if (!currentFavorites.includes(soundId)) {
      await setDoc(
        soundMasterSettingsRef(uid),
        {
          favoriteSounds: [soundId, ...currentFavorites],
          updatedAt: Timestamp.now(),
        },
        { merge: true }
      );
    }
  };

export const removeFavoriteSound =
  (uid: string, soundId: string): DefaultThunk =>
  async (_, getState) => {
    const state = getState();
    const currentFavorites = getFavoriteSounds(state);

    await setDoc(
      soundMasterSettingsRef(uid),
      {
        favoriteSounds: currentFavorites.filter((id: string) => id !== soundId),
        updatedAt: Timestamp.now(),
      },
      { merge: true }
    );
  };

export const removeFavoriteSoundByIds =
  (uid: string, soundIds: string[]): DefaultThunk =>
  async (_, getState) => {
    const state = getState();
    const currentFavorites = getFavoriteSounds(state);

    await setDoc(
      soundMasterSettingsRef(uid),
      {
        favoriteSounds: currentFavorites.filter(
          (id: string) => !soundIds.includes(id)
        ),
        updatedAt: Timestamp.now(),
      },
      { merge: true }
    );
  };

// SoundMaster Histories
export const addSoundMasterHistories =
  (uid: string, soundId: string): DefaultThunk =>
  async (_, getState) => {
    const state = getState();
    const current = getSoundsHistories(state);

    const withoutSoundId = current.filter((id: string) => id !== soundId);
    await setDoc(
      soundMasterSettingsRef(uid),
      {
        soundHistories: [soundId, ...withoutSoundId].slice(0, 100),
        updatedAt: Timestamp.now(),
      },
      { merge: true }
    );
  };
